import {ErrorMessage} from '../../components/form/error-message.js'
import {FieldRoot} from '../../components/form/field-root.js'
import {useFieldContext} from '../../integrations/form/index.js'
import {CheckboxRootProps as ChakraCheckboxProps, Checkbox as ChakraCheckBox, Stack, Box} from '@chakra-ui/react'

interface Props extends ChakraCheckboxProps {
  label: string
  description?: string
}

export function CheckBox({label, description, ...props}: Props) {
  const field = useFieldContext<boolean>()

  return (
    <FieldRoot required={props.required} disabled={props.disabled}>
      <ChakraCheckBox.Root
        size="md"
        name={field.name}
        checked={field.state.value}
        onCheckedChange={changes => field.handleChange(Boolean(changes.checked))}
        alignItems="flex-start"
        {...props}
      >
        <ChakraCheckBox.HiddenInput />
        <ChakraCheckBox.Control bg={field.state.value ? undefined : 'bg'} />
        <Stack gap="1">
          <ChakraCheckBox.Label>{label}</ChakraCheckBox.Label>
          {description && (
            <Box textStyle="sm" color="fg.muted">
              {description}
            </Box>
          )}
        </Stack>
      </ChakraCheckBox.Root>

      <ErrorMessage />
    </FieldRoot>
  )
}
